// Yeni Alt Hesap Ekle / Alt Hesap Düzenle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.addSubAccount';

export const addBankSubAccountGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Alt hesap nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Alt hesap, bir banka hesabının altında ayrı bakiye tutan hesaptır (ör. aynı bankadaki POS hesabı veya döviz hesabı). Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Alt hesap ve ana banka'),
    body: t(`${G}.regions.body`, 'Alt hesap bilgileri'),
    footer: t(`${G}.regions.footer`, 'Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Hangi bankanın altına ekleniyor?'),
      text: t(`${G}.s1.text`, 'Başlıkta ana banka hesabının adı yazar ("Yeni Alt Hesap Ekle - Banka"). Pencereyi Banka listesinde ana hesabın ⋮ menüsündeki "Alt Hesap Ekle" ile açarsınız; düzenlemek için alt hesap satırındaki Düzenle\'yi kullanın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Alt hesap ekleme yalnız işletme sahibine açıktır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Hesap adı ve numarası'),
      text: t(`${G}.s2.text`, 'Hesap Adı (ör. "POS Hesabı", "USD Hesabı") ve Hesap Numarası zorunludur. Hesap numarası yalnız rakamlardan oluşmalı ve en az 5 haneli olmalıdır. IBAN isteğe bağlıdır; girerseniz TR ile başlayan 26 karakter olmalıdır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Para birimi'),
      text: t(`${G}.s3.text`, 'Alt hesabın para birimi ana hesaptan farklı olabilir. Listede TRY ile şirket ayarlarında açık olan dövizler bulunur. Transfer ve virman yalnız aynı para birimindeki hesaplar arasında yapılabilir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. POS ve Çek işaretleri'),
      text: t(`${G}.s4.text`, 'POS Hesabı açıksa alt hesap, satış ekranlarının ödeme ayarlarında POS ödeme seçeneğine bağlanabilir. Çek Hesabı açıksa alt hesabın ⋮ menüsünde Çek Defterleri görünür.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Kaydet" (düzenlemede "Güncelle") zorunlu alanlar dolunca açılır. Alt hesap 0 bakiyeyle açılır ve kendi bakiyesini tutar; ana hesabın bakiyesine eklenmez.'),
      tips: [
        t(`${G}.s5.tip1`, 'İşlem geçmişi olan alt hesap silinemez.'),
        t(`${G}.s5.tip2`, 'Alt hesabı olan ana banka hesabını silmek için önce alt hesaplarını silmeniz gerekir.'),
      ],
    },
  ],
});
